import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Button, Grid, Input} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import LabelsReprinterTable from './table';
import './labelsReprint.scss';

const labelsType = ['Stock', 'Back Order'];

class LabelsReprinter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'invoiceSelected': '',
      'filterBoxText': '',
      'filterPartCodeText': '',
      'labelType': '',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.LabelsReprinter, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.changeLabelsListPage(0);
    this.emptyLabelsForInvoiceSelected();
    this.props.fetchPendingInvoicesToBin();
  }

  emptyLabelsForInvoiceSelected() {
    this.props.emptyLabels();
    this.props.emptyInfo();
  }
  
  getInvoices() {
    return this.props.invoices.map((item) => {
      return {'text': item.invoice, 'value': item.invoice};
    });
  }

  getlabelsType() {
    return labelsType.map((type) => {
      return {'text': type, 'value': type.toUpperCase()};
    });
  }

  changeInvoice(value) {
    if (value === this.state.invoiceSelected) {
      return;
    }
    this.setState({'invoiceSelected': value});
    this.emptyLabelsForInvoiceSelected();
  }

  changeLabelType(value) {
    if (value === this.state.labelType) {
      return;
    }
    this.setState({'labelType': value});
  }

  onBoxFilterChange(event) {
    this.setState({'filterBoxText': (event.target.value).toUpperCase()});
  }

  onPartCodeFilterChange(event) {
    this.setState({'filterPartCodeText': (event.target.value).toUpperCase()});
  }

  onCancelClick() {
    this.setState({
      'invoiceSelected': '',
      'filterBoxText': '',
      'filterPartCodeText': '',
      'labelType': '',
    });
    this.emptyLabelsForInvoiceSelected();
    this.props.changeLabelsListPage(0);
  }

  onSearch() {
    const {invoiceSelected, filterBoxText, filterPartCodeText, labelType} = this.state;
    const box = filterBoxText;
    const partCode = filterPartCodeText;
    this.props.fetchInvoiceInfo(invoiceSelected);
    this.props.fetchLabelsByInvoice(invoiceSelected, {box, partCode, labelType});
    this.props.changeLabelsListPage(0);
  }

  render() {
    const {invoiceSelected, filterBoxText, filterPartCodeText, labelType} = this.state;
    const {loadingInvoices, invoiceInfo} = this.props;
    const providerOrigin = invoiceInfo.providerOrigin ? ` | ${invoiceInfo.providerOrigin}` : '';
    return (
      <div className='labels-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Reimpresión de Etiquetas</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={loadingInvoices || (!invoiceSelected && !filterBoxText && !filterPartCodeText)}
                  onClick={this.onCancelClick.bind(this)}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={loadingInvoices || !invoiceSelected}
                  onClick={this.onSearch.bind(this)}
                >
                  Buscar
                </Button>
              </div>
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Número Factura</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Dropdown selection
                      options={this.getInvoices()}
                      search
                      value={invoiceSelected}
                      disabled={loadingInvoices}
                      loading={loadingInvoices}
                      onChange={(e, {value}) => this.changeInvoice(value)}
                      placeholder='Seleccione Factura'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Caja No.</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Input
                      placeholder='Caja'
                      value={filterBoxText}
                      onChange={this.onBoxFilterChange.bind(this)}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Código</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Input
                      placeholder='Código'
                      value={filterPartCodeText}
                      onChange={this.onPartCodeFilterChange.bind(this)}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Tipo de Etiqueta</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Dropdown selection
                      options={this.getlabelsType()}
                      search={false}
                      value={labelType}
                      onChange={(e, {value}) => this.changeLabelType(value)}
                      placeholder='Seleccione Tipo Etiqueta'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            {
              invoiceSelected &&
              <div className='subtitle'>
                {invoiceInfo.providerName} {providerOrigin}
              </div>
            }
          </div>
        </Card>

        <LabelsReprinterTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingInvoices': state.backOrders.loadingInvoices,
    'invoices': state.backOrders.listInvoices,
    'invoiceInfo': state.checking.invoiceInfo,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  emptyInfo,
  navigateTo,
  emptyLabels,
  fetchInvoiceInfo,
  fetchLabelsByInvoice,
  changeLabelsListPage,
  fetchPendingInvoicesToBin,
} = Actions;

export default connect(mapStateToProps, {
  emptyInfo,
  navigateTo,
  emptyLabels,
  fetchInvoiceInfo,
  fetchLabelsByInvoice,
  changeLabelsListPage,
  fetchPendingInvoicesToBin,
})(LabelsReprinter);
